// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1cd0i","itemTitle":"ClientEmergencyInfo_itemTitle__3K3as","itemText":"ClientEmergencyInfo_itemText__1CrUQ"};